import { useState, useEffect, useRef, forwardRef } from 'react';
import { useLanguage } from '../utils/LanguageContext';
import DynamicSelect from './common/DynamicSelect';
import translations from './ComponentsTranslations.lang.json';
import { useAuth } from '../utils/AuthContext';
import { useConfiguredPlaidLink } from '../utils/AppConfigContext';

const renderLinkedAccount = (option) => `${option.name} - ${option.type} (***${option.mask})`;

const ExternalAccountChooser = forwardRef(({ onChange }, ref) => {
  const { api } = useAuth();
  const { lang, currentLanguage } = useLanguage(translations);

  const [plaidLinkToken, setPlaidLinkToken] = useState(null);
  const linkProcessPromise = useRef();

  const handleStartLinkProcess = async () => {
    setPlaidLinkToken(await api.requestPlaidLinkToken({ languagePreference: currentLanguage }));
    return await new Promise((resolve) => (linkProcessPromise.current = { resolve }));
  };

  const config = {
    onSuccess: (plaidPublicToken, metadata) => {
      // console.log('Public Token:', plaidPublicToken);
      // console.log('Metadata:', metadata);

      const handleSuccess = async () => {
        try {
          await api.connectPlaidPublicToken(plaidPublicToken);
        } catch (error) {
          console.error('Error during Plaid connection or refreshing accounts:', error);
        } finally {
          linkProcessPromise.current.resolve();
        }
      };

      handleSuccess();
    },
    onExit: (err, metadata) => {
      // if (err != null) {
      //   console.error('Error:', err);
      // }
      // console.log('Exit metadata:', metadata);

      linkProcessPromise.current.resolve();
    },
    onEvent: (eventName, metadata) => {
      // console.log('Event Name:', eventName);
      // console.log('Event Metadata:', metadata);
    },
    token: plaidLinkToken,
  };
  const { open, ready } = useConfiguredPlaidLink(config);

  useEffect(() => {
    if (ready) {
      open();
    }
  }, [ready, open]);

  const loadLinkedAccountsAsOptions = async () => {
    const linkedAccounts = await api.getPlaidLinkedAccountsAsList();
    const options = linkedAccounts.map((account) => ({
      value: account.linkedAccountId,
      ...account,
    }));

    return options;
  };

  return (
    <DynamicSelect
      valueLoader={loadLinkedAccountsAsOptions}
      optionRenderer={renderLinkedAccount}
      onChange={onChange}
      defaultValueSelector={(options) => options[0].value}
      addHandler={handleStartLinkProcess}
      loadingText={lang('loadingAccounts')}
      errorText={lang('errorLoading')}
      selectText={lang('selectAccount')}
      addText={lang('addAccount')}
      ref={ref}
    />
  );
});

export { renderLinkedAccount };
export default ExternalAccountChooser;
